export default __webpack_public_path__ + "static/media/997.458da481.png";